const experimentConfig = {
  globalExperiment: {
    experimentId: 'Q4KMAh3BQ4qNUNsdMXdprg',
    running: true,
    loadingCover: true,
    sites: [
      'themeforest',
      'graphicriver',
      'codecanyon',
      'photodune',
      'threedocean',
      'videohive',
      'audiojungle'
    ],
    variantsWeights: [1, 9],
    variants: {
      0: {
        globalExperiment: false,
        homepageNewDesign: false
      },
      1: {
        globalExperiment: true,
        homepageNewDesign: true,
        categoryPageBlocksB: true
      }
    }
  },
  newHomepageExperiment: {
    experimentId: 'eCQGElkrSVqkXjHjD14dBg',
    running: true,
    sites: ['codecanyon', 'videohive', 'graphicriver'],
    loadingCover: true,
    requires: {
      globalExperiment: {
        variants: [1]
      }
    },
    variants: {
      0: {
        homepageNewDesign: false
      },
      1: {
        homepageNewDesign: true
      }
    }
  }
}

export default experimentConfig
